import * as React from "react";
import { useCallback, useEffect, useRef, useState } from "react";
import {
  IconCommand,
  IconDotsVertical,
  IconDownload,
  IconNoteOff,
  IconPlus,
  IconRecycle,
  IconSearch,
  IconSend,
  IconZoomFilled,
  IconZoomIn,
  IconAlertCircle,
  IconInfoCircle,
} from "@tabler/icons-react";
import "./tab.component.css";
import {
  Avatar,
  Button,
  Flex,
  Grid,
  Group,
  Menu,
  Select,
  Textarea,
  rem,
  Text,
  ActionIcon,
  TypographyStylesProvider,
  CloseButton,
  FileButton,
  LoadingOverlay,
  Loader,
  TextInput,
  Table,
  Tooltip,
  Box,
} from "@mantine/core";

import {
  convertSignType,
  getFormattedDateUTCPlus7,
  repositorySign,
  workerUrl,
} from "../../_base/_const/_constVar";
import { ContractSummaryPanel } from "../../component/ContractSummaryPanel";
import { NotificationExtension } from "../../_base/extension/NotificationExtension";
import { MessageResponse } from "../../model/MessageResponse";
import { TblDocument } from "../../model/TblDocument";
import { GetStepSignModel } from "../../model/GetStepSignModel";
import { ScrollArea, Title } from "@mantine/core";
import { IconSignature, IconTrash, IconWritingSign } from "@tabler/icons-react";
import { modals } from "@mantine/modals";
import "./pdf.component.css";
import { SignAccessModel } from "../../model/SignAccessModel";
import { IconUpload, IconPhoto, IconX } from "@tabler/icons-react";
import { Dropzone, IMAGE_MIME_TYPE } from "@mantine/dropzone";
import { TestModel } from "../../stories/TestModel";
import { useStepSignStore } from "../../store";
import { DragDropContext, Droppable, Draggable } from "@hello-pangea/dnd";
import cx from "clsx";
import { randomId, useDisclosure } from "@mantine/hooks";
import {
  LocalizationMap,
  Viewer,
  Worker,
  SpecialZoomLevel,
  RenderPage,
  RenderPageProps,
} from "@react-pdf-viewer/core";
import { defaultLayoutPlugin } from "@react-pdf-viewer/default-layout";
import { renderPremiumToolbar } from "../../component/PremiumPdfToolbar";
import de_DE from "@react-pdf-viewer/locales/lib/vi_VN.json";
import "@react-pdf-viewer/core/lib/styles/index.css";
import "@react-pdf-viewer/default-layout/lib/styles/index.css";
import { ClassAttributes, HTMLAttributes } from "react";
import { Code, JsonInput } from "@mantine/core";
import { useMove } from "@mantine/hooks";
import "@mantine/core/styles.css";
import "@mantine/notifications/styles.css";
import "@mantine/dropzone/styles.css";
import "./Main.css";
import "@react-pdf-viewer/core/lib/styles/index.css";
import "@react-pdf-viewer/page-navigation/lib/styles/index.css";
import {
  pageNavigationPlugin,
  RenderCurrentPageLabelProps,
  RenderGoToPageProps,
} from "@react-pdf-viewer/page-navigation";
import { Rnd } from "react-rnd";

import Signature, { SignatureRef, StrokeOptions } from "@uiw/react-signature";
import { getFilePlugin, RenderDownloadProps } from "@react-pdf-viewer/get-file";
import { PDFDocument, rgb, StandardFonts } from "pdf-lib";
import { saveAs } from "file-saver";
import { TransformToolbarSlot } from "@react-pdf-viewer/toolbar";
import {
  useLocation,
  useNavigate,
  useParams,
  useSearchParams,
} from "react-router-dom";
import { ListStepSign, SignaturePage } from "../../model/SignPage";
import { uploadFile, UploadFileResult } from "../../_base/extension/Extension";
import {
  checkHacomSignPlugin,
  filesToSign,
  HacomSignPluginCheck,
  signFileWithPlugin,
  signPositionsForFile,
} from "../../_base/helper/HacomSignPlugin";
import { openHacomSignPluginModal } from "../../component/HacomSignPluginModal";
import {
  SelectListItem,
  SelectListItemBase,
} from "../../_base/model/_base/SelectListItemBase";
import { SignRejectModel } from "../../model/SignRejectModel ";
import { Loading } from "../../_base/component/_layout/Loading";

import { TblComment } from "../../model/Tblcomment";
import { formatDateTransfer } from "../../_base/extension/FormatDate";
import "@mantine/tiptap/styles.css";
import { RichTextEditor, Link } from "@mantine/tiptap";
import { useEditor } from "@tiptap/react";
import Highlight from "@tiptap/extension-highlight";
import StarterKit from "@tiptap/starter-kit";
import Underline from "@tiptap/extension-underline";
import TextAlign from "@tiptap/extension-text-align";
import Superscript from "@tiptap/extension-superscript";
import SubScript from "@tiptap/extension-subscript";
import { getUsersSelect } from "../../const/getSelectApi";
import fontkit from "@pdf-lib/fontkit";
import { ImageCore } from "../Flow-step/ImageCore";
import classes from "./TableScrollArea.module.css";
import PdfOnlyViewer from "../Flow-step/PdfOnlyViewer";
import { DelayTime } from "../../_base/helper/FunctionHelper";
const SignTopageAnonymous = () => {
  const location = useLocation();
  const [searchParams] = useSearchParams();

  let params = useParams();
  const navigate = useNavigate();
  const [urlFile, setUrlFile] = useState<string>("");
  const [saveFile, setSaveFile] = useState<Uint8Array>();
  const [selectFile, setSelectFile] = useState<string>("");
  const [listFile, setListFile] = useState<Array<string>>([]);
  const [documentData, setDocument] = useState<GetStepSignModel>();
  const [isView, setIsView] = useState<boolean>();
  //   const [listComment, setListComment] = useState<TblComment[]>();
  const [data, setData] = useState<Array<ListStepSign>>([]);
  const [employ, setEmployee] = useState<SelectListItem[]>([]);
  const [isLatestVersion, setIsLatestVersion] = useState<boolean | null>(null);
  const [isLoadingVersion, setIsLoadingVersion] = useState(false);
  const [pluginCheck, setPluginCheck] = useState<HacomSignPluginCheck>();
  const editor = useEditor({
    extensions: [
      StarterKit,
      Underline,
      Link,
      Superscript,
      SubScript,
      Highlight,
      TextAlign.configure({ types: ["heading", "paragraph"] }),
    ],
  });

  useEffect(() => {
    if (params?.id === "3017") {
      NotificationExtension.Fails("Hợp đồng này đang bị chặn !");
      navigate("/403");
    }

    if (!params.id || Number.parseInt(params.id) < 1) {
      //  navigate("/method/approve-task");
      window.location.href = location.pathname + "?view=1";
    } else {
      if (searchParams.get("view") === "1") {
        setIsView(true);
      } else setIsView(false);
      fetchDataEmployee();
      addLocationSign(Number.parseInt(params.id));
    }
  }, []);

  const applyPluginCheck = (check: HacomSignPluginCheck) => {
    setPluginCheck(check);
    setIsLatestVersion(check.status === "ready");
  };

  const checkVersion = async () => {
    setIsLoadingVersion(true);
    try {
      const check = await checkHacomSignPlugin();
      applyPluginCheck(check);
      return check;
    } finally {
      setIsLoadingVersion(false);
    }
  };

  // Khách ký số qua HacomSign /sign-v2: chữ ký được nhúng vào file (luồng cũ /sign chỉ ký hash, không nằm trong file).
  // Ký lần lượt mọi file có vị trí ký của bước rồi mới xác nhận với API.
  // Trả về true khi đã ký xong và đang chuyển trang: giữ khoá nút "Ký số" để không ký lại lần nữa
  const signDigitalWithPlugin = async (): Promise<boolean> => {
    const pages = data.flatMap((x) => x.list);
    const files = filesToSign(pages);
    if (files.length === 0) {
      NotificationExtension.Fails("Bước ký không có vị trí ký số nào chưa ký.");
      return false;
    }
    open();
    let signed = false;
    try {
      let companyOrPerson = "";
      for (const fileUrl of files) {
        const result = await signFileWithPlugin(
          fileUrl,
          signPositionsForFile(pages, fileUrl)
        );
        if (!result.ok) {
          NotificationExtension.Fails(result.message);
          return false;
        }
        companyOrPerson = result.companyOrPerson;
      }
      const entity: SignAccessModel = {
        listStepId: documentData?.liststepsign.id ?? 0,
        signaturePages: [],
        name: params.user,
        urlImage: "",
        base64a: "123",
        base64b: "123",
        nameCompany: companyOrPerson,
      };
      const resSign = await repositorySign.post<
        MessageResponse<SignAccessModel>
      >("/api/v1/SignPage/sign-access-v2", entity);
      if (resSign?.httpStatusCode === 200 && resSign.success) {
        NotificationExtension.Success("Ký thành công !");
        signed = true;
        setTimeout(() => {
          window.location.href = location.pathname + "?view=1";
        }, 500);
      } else
        NotificationExtension.Fails(
          resSign?.message ??
            "Không xác nhận được bước ký với máy chủ. Hãy tải lại trang để kiểm tra trước khi ký lại."
        );
      return signed;
    } finally {
      if (!signed) close();
    }
  };

  // Chặn bấm "Ký số" lần nữa khi đang kiểm tra hoặc đang ký, tránh ký một file hai lần
  const digitalSigningRef = useRef(false);
  const [isDigitalSigning, setIsDigitalSigning] = useState(false);
  const startDigitalSign = async () => {
    if (digitalSigningRef.current) return;
    digitalSigningRef.current = true;
    setIsDigitalSigning(true);
    let keepLocked = false;
    try {
      const check = await checkVersion();
      if (check.status !== "ready") {
        openHacomSignPluginModal(check, openInstallGuideModal, applyPluginCheck);
        return;
      }
      keepLocked = await signDigitalWithPlugin();
    } finally {
      if (!keepLocked) {
        digitalSigningRef.current = false;
        setIsDigitalSigning(false);
      }
    }
  };

  const openInstallGuideModal = () => {
    modals.open({
      title: "Hướng dẫn cài đặt trình ký số",
      size: "xl",
      children: (
        <ScrollArea.Autosize mah={600}>
          <Box p="md">
            <Text size="sm" mb="md" c="gray.7">
              Để cài đặt bộ cài mới nhất, vui lòng làm theo các bước sau:
            </Text>

            <Box mb="lg">
              <Text size="sm" fw={600} mb="xs" c="blue.7">
                Bước 1: Tải file gỡ cài đặt
              </Text>
              <Text size="sm" mb="xs" c="gray.7">
                Tải file <strong>UnInstallHacomEsign.cmd</strong> để gỡ toàn bộ các phiên bản cũ đang có trên máy tính của bạn.
              </Text>
              <Button
                component="a"
                href="/UnInstallHacomEsign.cmd"
                download="UnInstallHacomEsign.cmd"
                leftSection={<IconDownload size={16} />}
                variant="light"
                color="blue"
                mb="md"
                fullWidth
              >
                Tải file UnInstallHacomEsign.cmd
              </Button>
            </Box>

            <Box mb="lg">
              <Text size="sm" fw={600} mb="xs" c="blue.7">
                Bước 2: Chạy file gỡ cài đặt
              </Text>
              <Text size="sm" mb="xs" c="gray.7">
                1. Nhấp chuột phải vào file <strong>UnInstallHacomEsign.cmd</strong> và chọn <strong>"Chạy với tư cách quản trị viên hoặc run as administrator"</strong>
              </Text>
              <Text size="sm" mb="xs" c="gray.7">
                2. File sẽ tự động quét và tìm các phiên bản Hacom Sign đang có trên máy:
              </Text>
              <Box
                style={{
                  border: "1px solid #e9ecef",
                  borderRadius: "8px",
                  overflow: "hidden",
                  marginBottom: "12px",
                }}
              >
                <img
                  src="/anhquetverrsion.png"
                  alt="Kết quả quét version"
                  style={{
                    width: "100%",
                    height: "auto",
                    display: "block",
                  }}
                />
              </Box>
              <Text size="sm" mb="xs" c="gray.7">
                3. Nhập <strong>'y'</strong> để xác nhận gỡ cài đặt. Quá trình sẽ tự động:
              </Text>
              <Box component="ul" style={{ paddingLeft: "20px", marginTop: "8px" }}>
                <li style={{ marginBottom: "4px" }}>
                  <Text size="sm" c="gray.7">Đóng các ứng dụng Hacom Sign đang chạy</Text>
                </li>
                <li style={{ marginBottom: "4px" }}>
                  <Text size="sm" c="gray.7">Gỡ cài đặt từ Registry</Text>
                </li>
                <li style={{ marginBottom: "4px" }}>
                  <Text size="sm" c="gray.7">Xóa các file và thư mục còn sót lại</Text>
                </li>
              </Box>
              <Box
                style={{
                  border: "1px solid #e9ecef",
                  borderRadius: "8px",
                  overflow: "hidden",
                  marginTop: "12px",
                }}
              >
                <img
                  src="/anhketquasaukhiquetxong.png"
                  alt="Kết quả sau khi gỡ xong"
                  style={{
                    width: "100%",
                    height: "auto",
                    display: "block",
                  }}
                />
              </Box>
            </Box>

            <Box mb="lg">
              <Text size="sm" fw={600} mb="xs" c="blue.7">
                Bước 3: Tải và cài đặt bộ cài mới nhất
              </Text>
              <Text size="sm" mb="xs" c="gray.7">
                Sau khi gỡ xong, tải bộ cài trình ký số mới nhất và cài đặt như bình thường.
              </Text>
              <Button
                component="a"
                href="https://cdn-files.hacom.vn/hacom/extension/App-win/HacomSignSetup.exe"
                leftSection={<IconDownload size={16} />}
                variant="filled"
                color="blue"
                mt="xs"
                fullWidth
              >
                Tải bộ cài trình ký số mới nhất
              </Button>
            </Box>

            <Box
              style={{
                padding: "12px",
                backgroundColor: "#fff3cd",
                borderRadius: "6px",
                border: "1px solid #ffc107",
                marginTop: "16px",
              }}
            >
              <Text size="xs" c="orange.8" fw={500}>
                ⚠ Lưu ý: Quá trình gỡ cài đặt cần quyền Administrator. Vui lòng đảm bảo bạn đã chạy file với quyền quản trị viên.
              </Text>
            </Box>

            <Box
              style={{
                padding: "16px",
                backgroundColor: "#f8d7da",
                borderRadius: "8px",
                border: "2px solid #dc3545",
                marginTop: "20px",
              }}
            >
              <Text size="sm" fw={700} mb="md" c="red.8">
                ⚠️ CHÚ Ý QUAN TRỌNG: Cấp quyền truy cập mạng nội bộ
              </Text>
              <Text size="sm" mb="xs" c="gray.8" fw={500}>
                Một số máy tính có thể tắt chức năng truy cập mạng nội bộ, khiến không thể chạy test phiên bản hoặc ký số được vì call localhost báo lỗi.
              </Text>
              <Text size="sm" mb="md" c="gray.8" fw={500}>
                Để khắc phục, vui lòng làm theo các bước sau:
              </Text>

              <Box mb="md">
                <Text size="sm" fw={600} mb="xs" c="red.7">
                  Bước 1: Mở cài đặt trang web
                </Text>
                <Text size="sm" mb="xs" c="gray.7">
                  Nhấp vào biểu tượng khóa hoặc thông tin trang web ở thanh địa chỉ trình duyệt (bên trái URL)
                </Text>
              </Box>

              <Box mb="md">
                <Text size="sm" fw={600} mb="xs" c="red.7">
                  Bước 2: Bật quyền truy cập mạng nội bộ
                </Text>
                <Text size="sm" mb="xs" c="gray.7">
                  Tìm mục <strong>"Quyền truy cập mạng cục bộ"</strong> hoặc <strong>"Local network access"</strong> và bật chức năng này (chuyển sang màu xanh/ON)
                </Text>
                <Flex
                  gap="md"
                  mt="md"
                  direction={{ base: "column", sm: "row" }}
                >
                  <Box
                    style={{
                      border: "1px solid #e9ecef",
                      borderRadius: "8px",
                      overflow: "hidden",
                      flex: 1,
                    }}
                  >
                    <img
                      src="/anhcapquyentruycapmangnoibotiengviet.png"
                      alt="Cấp quyền truy cập mạng nội bộ (Tiếng Việt)"
                      style={{
                        width: "100%",
                        height: "auto",
                        display: "block",
                      }}
                    />
                  </Box>
                  <Box
                    style={{
                      border: "1px solid #e9ecef",
                      borderRadius: "8px",
                      overflow: "hidden",
                      flex: 1,
                    }}
                  >
                    <img
                      src="/anhcapquyentruycapmangnoibo.png"
                      alt="Cấp quyền truy cập mạng nội bộ (English)"
                      style={{
                        width: "100%",
                        height: "auto",
                        display: "block",
                      }}
                    />
                  </Box>
                </Flex>
              </Box>

              <Box
                style={{
                  padding: "10px",
                  backgroundColor: "#ffffff",
                  borderRadius: "6px",
                  border: "1px solid #dc3545",
                  marginTop: "12px",
                }}
              >
                <Text size="xs" c="red.8" fw={600}>
                  💡 Lưu ý: Sau khi bật quyền này, vui lòng tải lại trang để áp dụng thay đổi. Nếu vẫn gặp lỗi, hãy kiểm tra lại cài đặt tường lửa và phần mềm diệt virus.
                </Text>
              </Box>
            </Box>
          </Box>
        </ScrollArea.Autosize>
      ),
    });
  };

  useEffect(() => {
    checkVersion();
  }, []);

  const fetchDataEmployee = async () => {
    const dataApi = await getUsersSelect();
    if (dataApi && dataApi.length > 0) {
      const filteredData = dataApi.filter((item) => item.text !== null);
      setEmployee(filteredData);
    }
  };
  const addLocationSign = async function (id: number) {
    if (documentData) return;
    const url =
      "/api/v1/SignPage/get-step-sign?id=" +
      id +
      "&mail=" +
      params.user +
      "&isView=" +
      (searchParams.get("view") === "1");
    const res = await repositorySign.get<MessageResponse<GetStepSignModel>>(
      url
    );
    if (res && res.httpStatusCode === 200) {
      if (res.success) {
        const filesss = res.data.tblDocument.signedDocument.split("||") || [];
        const file = Array.from(new Set(filesss));
        if (!file) NotificationExtension.Fails("Không tìm được file");
        else {
          const _f = file[0];
          const get = _f.split("/") ?? [];
          if (get && get.length > 0) {
            const _file = get[get.length - 1];
            setSelectFile(_file);
            setUrlFile(_f);
            setListFile(file);
          }
        }
        let _data: ListStepSign = res.data?.liststepsign; // Provide a default empty array
        _data.list = [];
        // Now, _data.list is guaranteed to be an array (even if it's empty)
        _data.list.push(...(res.data?.signaturePages || [])); // Safely push, handling undefined signaturePages

        const paster: Array<ListStepSign> = [];
        paster.push(_data);
        setData(paster);
        setDocument(res.data);
        //   setListComment(res.data.comments);
      } else NotificationExtension.Fails(res.message);
    }
  };

  const [boundaryElm, setBoundaryElm] = useState<HTMLDivElement>();
  // const workerUrl = new URL(
  //   "pdfjs-dist/build/pdf.worker.min.js",
  //   import.meta.url
  // ).toString();
  const defaultLayoutPluginInstance = defaultLayoutPlugin({
    renderToolbar: renderPremiumToolbar,
  });
  // const disableScrollPluginInstance = disableScrollPlugin();
  const pageNavigationPluginInstance = pageNavigationPlugin();
  const [selectedItemId, setSelectedItemId] = useState<string>("");
  const {
    GoToFirstPage,
    GoToLastPage,
    GoToNextPage,
    GoToPreviousPage,
    CurrentPageLabel,
    jumpToPage,
  } = pageNavigationPluginInstance;

  const $svg = useRef<SignatureRef>(null);
  const [options, setOptions] = useState<StrokeOptions>({
    size: 5,
    smoothing: 0.5,
    thinning: 0.5,
    streamline: 0.3,
  });

  const renderPage: RenderPage = (props: RenderPageProps) => {
    return (
      <>
        {props.canvasLayer.children}
        {props.annotationLayer.children}
        {props.textLayer.children}
        {!isView &&
          data
            .filter((x) => {
              // console.log("Filtering documents:", x.typeSignCustomer !== 0);
              return x.typesigncustomer !== 0;
            })
            .map((doc, index) =>
              doc.list
                .filter((signaturePage) => {
                  //console.log("File comparison:", signaturePage.files, urlFile);
                  // console.log("check:", signaturePage.files === urlFile);
                  return (
                    signaturePage.page === props.pageIndex &&
                    signaturePage.files?.toString() === urlFile
                  );
                })
                .map((item, pageIndex) => (
                  <Rnd
                    key={item.key}
                    bounds={boundaryElm}
                    size={{
                      width: item.width,
                      height: item.height,
                    }}
                    position={{
                      x: item.x,
                      y: item.y,
                    }}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      borderRadius: "10px",
                      justifyContent: "center",
                      border:
                        selectedItemId === item.key
                          ? "solid 3.5px #228be6"
                          : "solid 2px #228be6", // Thay đổi màu border nếu item được chọn
                      background: "#fff",
                      color: "#228be6",
                      fontWeight: "bold",
                      zIndex: 9999,
                    }}
                  >
                    {`${doc.name} ${convertSignType(
                      Number(doc.typesigncustomer)
                    )} ở bước ${doc.numberstep} `}
                  </Rnd>
                ))
            )}
      </>
    );
  };

  const urlFront =
    "https://files.hacom.vn/hacom/Local/4oLmMUArial-Unicode-Regular (4).ttf";
  const [fontBytesFE, setFontBytes] = useState<ArrayBuffer>();
  useEffect(() => {
    const fetchFont = async () => {
      try {
        const response = await fetch(urlFront);
        const fontData = await response.arrayBuffer();
        setFontBytes(fontData);
      } catch (error) {
        console.error("Error fetching font:", error);
      }
    };

    fetchFont();
  }, []); // Empty dependency array means it runs only on mount

  useEffect(() => {
    if (saveFile) setData([]);
  }, [saveFile]);

  const [listFileUpload, setListFileUpload] = useState<Array<SelectListItem>>(
    []
  );
  const [fileSign, setFileSign] = useState<File | null>(null);
  const [imageUrl, setImageUrl] = useState<string | null>(null);

  useEffect(() => {
    if (fileSign) {
      const fileReader = new FileReader();
      fileReader.onload = () => {
        const imageData = fileReader.result;
        const imageUrl = `${imageData}`;
        setImageUrl(imageUrl);
      };
      fileReader.readAsDataURL(fileSign ?? new Blob());
    } else setImageUrl(null);
  }, [fileSign]);

  useEffect(() => {
    modals.closeAll();
    if (imageUrl && imageUrl.length > 0) showSignToHandeler();
  }, [imageUrl]);

  async function SignAcess(base: string) {
    if (!base || base.length < 10) {
      NotificationExtension.Fails("Bạn chưa vẽ chứ ký hoặc upload chữ ký !");
      return false;
    }
    if (base && base.length > 0) {
      const _user = params.user;
      let entity: SignAccessModel = {
        listStepId: documentData?.liststepsign.id ?? 0,
        name: _user,
        urlImage: base,
      };
      if (entity) {
        open();
        const urlApi = "/api/v1/SignPage/sign-access";
        var resSign = await repositorySign.post<
          MessageResponse<SignAccessModel>
        >(urlApi, entity);
        if (resSign && resSign.httpStatusCode === 200) {
          if (resSign.success) {
            NotificationExtension.Success("Ký tài liệu thành công !");
            setTimeout(() => {
              window.location.href = location.pathname + "?view=1";
            }, 500);
          } else
            NotificationExtension.Fails(
              resSign.message ?? "Ký tài liệu thất bại !"
            );
        }
        close();
      }
    } else {
      NotificationExtension.Fails("Upload chữ ký thất bại do server lỗi !");
      return false;
    }

    // if (!base || base.length < 10) {
    //   NotificationExtension.Fails("Bạn chưa vẽ chứ ký hoặc upload chữ ký !");
    //   return false;
    // }
    // const _file = dataURLtoFile(base, randomId() + "-signature.png");
    // if (!_file) {
    //   NotificationExtension.Fails("Lỗi chữ ký, xin thử lại !");
    //   return false;
    // }
    // const _url = await uploadFile([_file]);
    // if (_url && _url.length > 0) {
    //   const _user = employ.find(
    //     (x) => x.value === documentData?.liststepsign.username
    //   )?.text;
    //   let entity: SignAccessModel = {
    //     listStepId: documentData?.liststepsign.id ?? 0,
    //     name: _user,
    //     urlImage: _url[0].url,
    //   };
    //   if (entity) {
    //     console.log(entity);
    //     const urlApi = "/api/v1/SignPage/sign-access";
    //     var resSign = await repositorySign.post<
    //       MessageResponse<SignAccessModel>
    //     >(urlApi, entity);
    //     if (resSign && resSign.httpStatusCode === 200) {
    //       if (resSign.success) {
    //         NotificationExtension.Success("Ký tài liệu thành công !");
    //         setTimeout(() => {
    //           navigate("/method/approve-task");
    //         }, 2000);
    //       } else
    //         NotificationExtension.Fails(
    //           resSign.message ?? "Ký tài liệu thất bại !"
    //         );
    //     }
    //   }
    // } else {
    //   NotificationExtension.Fails("Upload chữ ký thất bại do server lỗi !");
    //   return false;
    // }
    // close();
  }

  function showSignToHandeler() {
    if (
      documentData?.liststepsign?.typesigncustomer &&
      documentData?.liststepsign?.typesigncustomer !== 0 &&
      documentData?.liststepsign?.typesigncustomer !== 2
    )
      modals.openConfirmModal({
        title: (
          <>
            <Title order={5}>Vẽ nội dung chữ ký vào bên dưới !</Title>
          </>
        ),

        size: "550px",
        children: (
          <>
            {" "}
            <Flex justify={"end"}>
              <Button
                size="xs"
                variant="outline"
                color="grape"
                leftSection={<IconRecycle />}
                onClick={() => {
                  $svg.current?.clear();
                  setImageUrl(null);
                  setFileSign(null);
                }}
                mb={10}
                mr={10}
              >
                Vẽ lại
              </Button>
              <FileButton onChange={setFileSign} accept="image/png">
                {(props) => (
                  <Button
                    size="xs"
                    variant="outline"
                    leftSection={<IconUpload />}
                    {...props}
                  >
                    {" "}
                    Chọn ảnh PNG
                  </Button>
                )}
              </FileButton>

              <Button
                disabled={!imageUrl}
                variant="outline"
                color="teal"
                size="xs"
                leftSection={<IconZoomIn />}
                onClick={() => {
                  modals.open({
                    title: "Xem ảnh",
                    children: (
                      <>
                        <ImageCore
                          h={"100%"}
                          src={imageUrl ?? ""}
                          fit="cover"
                        />
                      </>
                    ),
                  });
                }}
                mb={10}
                ml={10}
              >
                Xem ảnh phóng to
              </Button>
            </Flex>
            {imageUrl && imageUrl.length > 0 ? (
              <ImageCore src={imageUrl} />
            ) : (
              <Signature
                style={{
                  borderRadius: 5,
                  height: 210,
                  border: "1px solid #dee2e6",
                }}
                ref={$svg}
                options={options}
              />
            )}
          </>
        ),
        labels: { confirm: "Ký tài liệu", cancel: "Đóng" },
        onConfirm: async () => {
          // Tạo một SVG Data URL
          let _base64 = "";
          if ($svg.current?.svg && !imageUrl) {
            const svgelm = $svg.current?.svg?.cloneNode(true) as SVGSVGElement;
            const clientWidth = $svg.current?.svg?.clientWidth;
            const clientHeight = $svg.current?.svg?.clientHeight;
            svgelm.removeAttribute("style");
            svgelm.setAttribute("width", `${clientWidth}px`);
            svgelm.setAttribute("height", `${clientHeight}px`);
            svgelm.setAttribute("viewbox", `${clientWidth} ${clientHeight}`);
            const data = new XMLSerializer().serializeToString(svgelm);
            const canvas = document.createElement("canvas");
            const ctx = canvas.getContext("2d");
            const img = new Image();
            img.onload = async () => {
              canvas.width = clientWidth || 0;
              canvas.height = clientHeight || 0;
              ctx?.drawImage(img, 0, 0);
              const a = document.createElement("a");
              a.download = "signature.png";
              a.href = canvas.toDataURL("image/png");
              _base64 = a.href;
              console.log(_base64);
              await SignAcess(_base64);
            };
            img.src = `data:image/svg+xml;base64,${window.btoa(
              unescape(encodeURIComponent(data))
            )}`;
          } else if (imageUrl) {
            // let entity: SignAccessModel = {
            //   listStepId: documentData?.liststepsign.id ?? 0,
            //   signaturePages: [],
            // };
            console.log(imageUrl);
            await SignAcess(imageUrl);
          }
        },
      });
  }

  // write convert base64 png to File
  function dataURLtoFile(dataurl: string, filename: string) {
    if (!dataurl) return null;
    if (!filename) return null;
    var arr = dataurl.split(","),
      mime = arr[0].match(/:(.*?);/)?.[1],
      bstr = atob(arr[1]),
      n = bstr.length,
      u8arr = new Uint8Array(n);

    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }

    return new File([u8arr], filename, { type: mime });
  }

  const [visible, { toggle, open, close }] = useDisclosure(false);

  const [scrolled, setScrolled] = useState(false);

  // Giả sử `documentData` là kiểu `DocumentData | undefined`
  const groupedData = documentData?.signaturePages.reduce(
    (acc: Record<string, SignaturePage[]>, row) => {
      const key = row.namefilefrist;
      if (!acc[key]) {
        acc[key] = [];
      }
      acc[key].push(row);
      return acc;
    },
    {}
  );

  // Tạo các hàng trong bảng từ các nhóm
  const rows = Object.keys(groupedData || {}).map((namefilefrist) => {
    const firstRow = groupedData![namefilefrist][0];
    return (
      <Table.Tr key={namefilefrist}>
        <Table.Td>{namefilefrist.slice(6)}</Table.Td>
        {/* <Table.Td>{documentData?.liststepsign.username}</Table.Td> */}
        <Table.Td>{formatDateTransfer(firstRow.datesign)}</Table.Td>
        <Table.Td>
          {" "}
          <ActionIcon
            onClick={async () => {
              try {
                const pdfBytes = await fetch(firstRow.files).then((res) =>
                  res.arrayBuffer()
                );
                saveAs(
                  new Blob([pdfBytes], { type: "application/pdf" }),
                  firstRow.namefilefrist
                );
              } catch (error) {
                console.log(error);
                NotificationExtension.Info("Có lỗi khi download file !");
              }
            }}
            variant="outline"
            aria-label="Settings"
          >
            <IconDownload
              style={{ width: "70%", height: "70%" }}
              stroke={1.5}
            />
          </ActionIcon>
        </Table.Td>
      </Table.Tr>
    );
  });

  return (
    <>
      <style>
        {`
          @keyframes blink {
            0%, 100% { opacity: 1; }
            50% { opacity: 0.3; }
          }
        `}
      </style>
      <Box
        style={{
          background: "#fffbe6",
          border: "1px solid #ffe58f",
          padding: "8px",
          marginBottom: "10px",
          borderRadius: "6px",
          fontWeight: 600,
          color: "#ad8b00",
          fontSize: "16px",
          textAlign: "center",
        }}
      >
        ⚠️<span style={{ textDecoration: "underline" }}>Lưu ý:</span> Vui lòng
        kiểm tra phiên bản phần mềm trước khi ký (áp dụng cho loại là ký số).
        Cần bản <b>{pluginCheck?.minVersion ?? "1.0.7"}</b> trở lên.
        <a
          href={
            pluginCheck?.downloadUrl ??
            "https://cdn-files.hacom.vn/hacom/extension/App-win/HacomSignSetup.exe"
          }
          rel="noopener noreferrer"
          style={{ color: "#0078cb" }}
        >
          Truy cập tại đây
        </a>
        .
      </Box>
      <LoadingOverlay
        visible={visible}
        zIndex={1000}
        overlayProps={{ radius: "sm", blur: 5 }}
        loaderProps={{
          children: (
            <Flex direction={"column"} align="center" gap="xs">
              <Loader type="dots" size={35}></Loader>
              <Title size={15}>
                {" "}
                Đang xác thực tài liệu và ký. Quá trình có thể mất nhiều thời
                gian do chính sách bảo mật...
              </Title>
            </Flex>
          ),
        }}
      />
      {documentData && (
        <>
          <Grid>
            <Grid.Col span={{ base: 12, sm: 6 }}>
              <Flex
                gap="xs"
                justify="flex-start"
                align="center"
                direction="row"
                wrap="wrap"
              >
                Chọn tài liệu
                <Select
                  label=""
                  key={randomId()}
                  placeholder="Chọn..."
                  value={selectFile}
                  onChange={(e) => {
                    const _key = e ?? "";
                    setSelectFile(_key);
                    if (_key.length > 1) {
                      const file = listFile.find((x) => x.includes(_key));
                      if (file) setUrlFile(file);
                    }
                  }}
                  data={listFile.map((x) => ({
                    label: x.split("/")[x.split("/").length - 1].slice(6),
                    value: x.split("/")[x.split("/").length - 1],
                  }))}
                />
                {documentData?.liststepsign?.typesigncustomer === 2 && (
                  <>
                    {/* <Button
                      leftSection={<IconSearch size={14} />}
                      color="teal"
                      variant="outline"
                      onClick={() => {
                        NotificationExtension.Info(
                          "Chức năng đang được phát triển!"
                        );
                      }}
                    >
                      Kiểm tra chữ ký số
                    </Button> */}
                    <Box
                      style={{
                        padding: "8px 12px",
                        backgroundColor: "#f8f9fa",
                        borderRadius: "6px",
                        border: "1px solid #e9ecef",
                        minWidth: "200px",
                      }}
                    >
                      <Flex justify="space-between" align="center" gap="sm">
                        <Box>
                          {isLoadingVersion ? (
                            <Text size="xs" c="gray.6">
                              Đang kiểm tra version...
                            </Text>
                          ) : isLatestVersion === true ? (
                            <Text size="xs" c="green.6" fw={500}>
                              ✓ Bộ cài mới nhất
                            </Text>
                          ) : (
                            <Flex align="center" gap="xs">
                              <Text size="xs" c="orange.6" fw={500}>
                                {pluginCheck?.status === "notRunning"
                                  ? "⚠ Chưa kết nối HacomSign"
                                  : "⚠ Cần cập nhật HacomSign"}
                              </Text>
                              <IconAlertCircle
                                color="#ff6b6b"
                                size={14}
                                style={{
                                  animation: "blink 1s infinite",
                                }}
                              />
                            </Flex>
                          )}
                        </Box>
                        <Button
                          size="xs"
                          variant="light"
                          onClick={checkVersion}
                          loading={isLoadingVersion}
                          style={{
                            flexShrink: 0,
                          }}
                        >
                          Kiểm tra
                        </Button>
                      </Flex>
                      <Button
                        size="xs"
                        variant="subtle"
                        onClick={openInstallGuideModal}
                        leftSection={<IconInfoCircle size={14} />}
                        mt="xs"
                        fullWidth
                        color="blue"
                      >
                        Hướng dẫn cài đặt
                      </Button>
                    </Box>
                  </>
                )}
              </Flex>
            </Grid.Col>
            {!isView && (
              <Grid.Col span={{ base: 12, sm: 6 }}>
                {" "}
                <Flex
                  gap="md"
                  justify={{ sm: "flex-start", lg: "flex-end" }}
                  align="center"
                  direction="row"
                  wrap="wrap"
                >
                  {1 === 1 &&
                    documentData?.liststepsign?.typesigncustomer != null &&
                    documentData?.liststepsign?.typesigncustomer > 0 && (
                      <>
                        {" "}
                        <Button
                          leftSection={<IconWritingSign />}
                          color=""
                          variant="outline"
                          loading={isDigitalSigning}
                          onClick={async () => {
                            if (
                              documentData?.liststepsign?.typesigncustomer === 2
                            ) {
                              await startDigitalSign();
                            } else {
                              if (
                                documentData.sign &&
                                documentData.sign.length > 0
                              ) {
                                await SignAcess(documentData.sign);
                              } else showSignToHandeler();
                            }
                          }}
                          size="xs"
                        >
                          {documentData?.liststepsign?.typesigncustomer === 1
                            ? "Ký ảnh"
                            : documentData?.liststepsign?.typesigncustomer === 2
                              ? "Ký số"
                              : "Ký nháy"}
                        </Button>
                        {documentData?.liststepsign?.typesigncustomer === 2 && (
                          <>
                            <Tooltip label="Phần mềm hỗ trợ ký số">
                              <Button
                                variant="outline"
                                color="blue"
                                size="xs"
                                leftSection={<IconDownload />}
                                onClick={() => {
                                  window.location.href =
                                    pluginCheck?.downloadUrl ??
                                    "https://cdn-files.hacom.vn/hacom/extension/App-win/HacomSignSetup.exe";
                                }}
                              >
                                Tải phần mềm ký số
                              </Button>
                            </Tooltip>
                          </>
                        )}
                      </>
                    )}

                  {documentData?.liststepsign?.typesigncustomer != null &&
                    documentData?.liststepsign?.typesigncustomer === 0 && (
                      <Button
                        leftSection={<IconSignature />}
                        color=""
                        variant="outline"
                        onClick={async () => {
                          let entity: SignAccessModel = {
                            listStepId: documentData?.liststepsign.id ?? 0,
                            signaturePages: [],
                            name: params.user,
                          };
                          if (entity) {
                            open();
                            const urlApi = "/api/v1/SignPage/sign-access";
                            var resSign = await repositorySign.post<
                              MessageResponse<SignAccessModel>
                            >(urlApi, entity);
                            if (resSign && resSign.httpStatusCode === 200) {
                              if (resSign.success) {
                                NotificationExtension.Success(
                                  "Duyệt tài liệu thành công !"
                                );
                                setTimeout(() => {
                                  //                                 navigate("/method/approve-task");
                                  window.location.href =
                                    location.pathname + "?view=1";
                                }, 500);
                              } else
                                NotificationExtension.Fails(
                                  resSign.message ?? "Duyệt tài liệu thất bại !"
                                );
                            }
                            close();
                          } else
                            NotificationExtension.Fails(
                              "Lỗi khi duyệt chữ ký !"
                            );
                        }}
                      >
                        Phê duyệt
                      </Button>
                    )}

                  <Button
                    leftSection={<IconNoteOff />}
                    color="orange"
                    variant="outline"
                    onClick={async () => {
                      let entity: SignRejectModel = {
                        listStepId: documentData?.liststepsign.id ?? 0,
                        setupId:
                          documentData?.liststepsign.idsetupstepsign ?? 0,
                      };
                      if (entity) {
                        const urlApi = "/api/v1/SignPage/sign-reject";
                        var resSign = await repositorySign.post<
                          MessageResponse<SignAccessModel>
                        >(urlApi, entity);
                        if (resSign && resSign.httpStatusCode === 200) {
                          if (resSign.success) {
                            NotificationExtension.Success("Thành công !");
                            setTimeout(() => {
                              //      navigate("/method/approve-task");
                              window.location.href =
                                location.pathname + "?view=1";
                            }, 500);
                          } else
                            NotificationExtension.Fails(
                              resSign.message ?? "Thất bại !"
                            );
                        }
                      } else
                        NotificationExtension.Fails("Lỗi khi từ chối duyết !");
                    }}
                  >
                    Từ chối
                  </Button>
                  {/* <Button
                  variant="outline"
                  color="grape"
                  leftSection={<IconCommand />}
                  onClick={async () => {
                    await addComment();
                  }}
                >
                  Viết comment
                </Button> */}
                </Flex>
              </Grid.Col>
            )}
          </Grid>

          <Grid>
            <Grid.Col span={{ base: 12, sm: 7, md: 7 }}>
              {urlFile && !isView && (
                <div className="e-card" id="weather_card">
                  <div
                    className="rpv-core__viewer"
                    style={{
                      border: "1px solid rgba(0, 0, 0, 0.3)",
                      display: "flex",
                      flexDirection: "column",
                      height: "100%",
                    }}
                  >
                    <Group justify="center">
                      {urlFile && (
                        <div
                          className="App"
                          ref={(ref) => setBoundaryElm(ref!)}
                        >
                          <Worker workerUrl={workerUrl}>
                            <Viewer
                              localization={de_DE as unknown as LocalizationMap}
                              fileUrl={saveFile ? saveFile : urlFile}
                              plugins={[
                                defaultLayoutPluginInstance,
                                pageNavigationPluginInstance,
                              ]}
                              defaultScale={SpecialZoomLevel.ActualSize}
                              renderPage={!isView ? renderPage : undefined}
                            />
                          </Worker>
                        </div>
                      )}
                    </Group>
                  </div>
                </div>
              )}
              {urlFile &&
                urlFile.length > 0 &&
                urlFile.startsWith("http") &&
                isView && (
                  <div className="control-section">
                    <PdfOnlyViewer files={urlFile} cache={false} />
                  </div>
                )}
            </Grid.Col>
            <Grid.Col span={{ base: 12, sm: 5, md: 5 }}>
              {documentData?.tblDocument?.id && documentData.tblDocument.id > 0 ? (
                <ContractSummaryPanel documentId={documentData.tblDocument.id} />
              ) : null}
              <div className="e-card" id="weather_card">
                <div className="e-card-header">
                  <div className="e-card-header-caption">
                    <div className="e-card-header-title e-card-3">
                      Chi tiết trao đổi
                    </div>
                    <ScrollArea h={"75vh"} scrollbars="y">
                      <Grid>
                        <Grid.Col span={{ base: 12 }}>
                          <Grid mt={"sm"}>
                            <Grid.Col span={{ base: 2 }}>
                              <Title variant="unstyled" order={6}>
                                Loại hồ sơ
                              </Title>
                            </Grid.Col>
                            <Grid.Col span={{ base: 10 }}>
                              {documentData.tblDocument.description}
                            </Grid.Col>
                          </Grid>
                          <Grid mt={"xs"}>
                            <Grid.Col span={{ base: 2 }}>
                              <Title variant="unstyled" order={6}>
                                Mã hồ sơ
                              </Title>
                            </Grid.Col>
                            <Grid.Col span={{ base: 8 }}>
                              {documentData.tblDocument.code}
                            </Grid.Col>
                          </Grid>

                          <Grid mt={"xs"}>
                            <Grid.Col span={{ base: 2 }}>
                              <Title variant="unstyled" order={6}>
                                Tên hồ sơ
                              </Title>
                            </Grid.Col>
                            <Grid.Col span={{ base: 10 }}>
                              {documentData.tblDocument.name}
                            </Grid.Col>
                          </Grid>

                          <Grid mt={"xs"}>
                            <Grid.Col span={{ base: 2 }}>
                              <Title variant="unstyled" order={6}>
                                Mô tả
                              </Title>
                            </Grid.Col>
                            <Grid.Col span={{ base: 10 }}></Grid.Col>
                          </Grid>
                          <Grid mt={"xs"}>
                            <Grid.Col span={{ base: 12 }}>
                              <ScrollArea
                                h={300}
                                onScrollPositionChange={({ y }) =>
                                  setScrolled(y !== 0)
                                }
                              >
                                <Table>
                                  <Table.Thead
                                    className={cx(classes.header, {
                                      [classes.scrolled]: scrolled,
                                    })}
                                  >
                                    <Table.Tr>
                                      <Table.Th>Tên tài liệu</Table.Th>
                                      {/* <Table.Th>Người tạo</Table.Th> */}
                                      <Table.Th>Ngày cập nhật</Table.Th>
                                      <Table.Th>Hành động</Table.Th>
                                    </Table.Tr>
                                  </Table.Thead>
                                  <Table.Tbody>{rows}</Table.Tbody>
                                </Table>
                              </ScrollArea>
                            </Grid.Col>
                          </Grid>
                        </Grid.Col>
                        <Grid.Col span={{ base: 12 }}>
                          {" "}
                          <Grid
                            style={{
                              position: "absolute",
                              bottom: 10,
                              width: "100%",
                              // height: "70px",
                            }}
                            align="center"
                          ></Grid>
                        </Grid.Col>
                      </Grid>
                    </ScrollArea>
                  </div>
                </div>
              </div>
            </Grid.Col>
          </Grid>
        </>
      )}

      {!documentData && <Loading />}
    </>
  );
};
export default SignTopageAnonymous;
